import { BaseUrlFormatter } from "../../../base";
export class MarketsBffUrlFormatter extends BaseUrlFormatter {
    composeEndpoint(request) {
        const { pageType, feature } = request;
        return `${pageType}/${feature}/v1/markets`;
    }
}
//# sourceMappingURL=MarketsBffUrlFormatter.js.map